import TimelineConnector from '@mui/lab/TimelineConnector';
export default TimelineConnector;
export * from '@mui/lab/TimelineConnector';
